import hasServiceFamily, {IHasServiceFamily} from "@/model/mixins/ServiceFamily/hasServiceFamily"


class ServiceFamilyConfigBase {
    protected embededFamilies: string[]
    protected expanded: boolean
    protected familyId: string

    constructor(
        embededFamilies: string[],
        expanded: boolean,
        familyId: string,
    ) {
        this.embededFamilies = embededFamilies
        this.expanded = expanded
        this.familyId = familyId
    }
    
    public getEmbededFamilies(): string[] {
        return this.embededFamilies
    }
    public getExpanded(): boolean {
        return this.expanded
    }
    public getFamilyId(): string {
        return this.familyId
    }
}

export interface IServiceFamilyConfig extends ServiceFamilyConfigBase, IHasServiceFamily {
    getEmbededFamilies(): string[]
    getExpanded(): boolean
    getFamilyId(): string
}

const ServiceFamilyConfig: Constructor<IServiceFamilyConfig> = hasServiceFamily(ServiceFamilyConfigBase) 

export default ServiceFamilyConfig 